import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Warning({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.3527 14.8282H11.6142L11.1891 10.9345V9.16667H12.7779V10.9345L12.3527 14.8282Z"
        fill={iconColor}
      />
      <Path
        d="M12.8003 17.1667H11.1667V15.5443H12.8003V17.1667Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        d="M10.8527 4.66667C11.3659 3.77778 12.6489 3.77778 13.1621 4.66667L20.8601 18C21.3733 18.8889 20.7318 20 19.7054 20H4.30938C3.28298 20 2.64148 18.8889 3.15468 18L10.8527 4.66667ZM12.0074 5.33333L19.7054 18.6667H4.30938L12.0074 5.33333Z"
        fill={iconColor}
      />
    </Svg>
  );
}
